<template>
    <NuxtLink v-if="href" :to="$withLocalePrefix(href)" class="trends-tag" target="_blank">
        {{ text }}
    </NuxtLink>
    <span v-else class="trends-tag">
        {{ text }}
    </span>
</template>

<script setup lang="ts">
    export type TrendTagItem = {text: string; href?: string};
    defineProps<TrendTagItem>();
</script>

<style lang="scss">
    .trends-tag {
        display: block;
        padding: var(--joy-core-spacing-1) var(--joy-core-spacing-3);
        line-height: 1.5;
        border-radius: var(--joy-core-radius-3);
        background-color: var(--joy-color-brand-primary-10);
        font-weight: var(--joy-font-weight-normal);
        color: var(--joy-color-neutral-60);
        transition: filter var(--joy-transition-duration-short) var(--joy-transition-timing-function);
        -webkit-user-drag: none;
        user-select: none;
        text-decoration: none;

        &:hover {
            filter: brightness(97%);
            color: var(--joy-color-neutral-70);
        }
    }
</style>
